<template>
  <div class="hello">
    <!-- 形象圖 -->
    <transition name="fade">
    <section class="main_section" v-bind:class="{ 'pic--1': slogan === 1, 'pic--2': slogan === 2 }">
      <div class="slogan" v-if="slogan === 1">
        <span class="title">來趟小旅行一塊學英語！</span>
        <p class="desc">「遊臺中學英語」提供創新型態的學習服務，透過熱門景點進行影音互動學習。和我們一起快樂玩，輕鬆學，走遍臺中景點，學好旅遊英語，收藏在地旅行的動人回憶。</p>
      </div>

      <div class="slogan2" v-if="slogan === 2">
        <span class="title">遊臺中學英語 APP</span>
        <p>臺中就是你的英語教室</p>
      </div>

      <div class="sloganPagination text-xs-center">
        <v-btn class="bg--primary" small floating v-on:click.native="sloganClick(1)">1</v-btn>
        <v-btn class="bg--primary" small floating v-on:click.native="sloganClick(2)">2</v-btn>
      </div>
    </section>
    </transition>

    <!-- 功能特色 -->
    <section class="pa-5 bg--white" id="anchor-1">
      <h4 class="title">功能特色</h4>
      <p class="desc">四大學習功能讓您邊玩邊學</p>

      <v-row class="text-xs-left">
        <v-col sm5 offset-sm1 pa-3>
          <v-row>
            <v-col xs3 class="text-xs-center">
              <img src="~../assets/images/icon_video.svg" />
            </v-col>
            <v-col xs9>
              <span class="sub-title">互動課程</span>
              <p>包含實用會話、影音簡介、圖解單字與學習任務等學習功能，想知道臺中哪裡好玩，想要身歷其境，現場即時學英語，請立刻下載，讓『遊臺中學英語』 APP 陪你一起暢遊臺中學英語。</p>
            </v-col>
          </v-row>
        </v-col>

        <v-col sm5 pa-3>
          <hr class="hidden-sm-and-up" style="margin-bottom: 1.5em;" />
          <v-row>
            <v-col xs3 class="text-xs-center">
              <img src="~../assets/images/icon_coin.svg" />
            </v-col>
            <v-col xs9>
              <span class="sub-title">闖關任務 / 金幣兌換</span>
              <p>每個景點都規劃了英語學習任務，讓學習者從問答中認識景點特色及相關英語，讓你邊玩邊學好英語，答對可獲得金幣，還能兌換禮物哦！</p>
            </v-col>
          </v-row>
        </v-col>

        <v-col sm5 offset-sm1>
          <hr style="margin-bottom: 1.5em;" />
          <v-row>
            <v-col xs3 class="text-xs-center">
              <img src="~../assets/images/icon_location.svg" />
            </v-col>
            <v-col xs9>
              <span class="sub-title">GPS定位</span>
              <p>使用 GPS 定位快速找到鄰近的景點，跟著 APP 吃喝玩樂學英語，來趟不一樣的深度臺中之旅。</p>
            </v-col>
          </v-row>
        </v-col>

        <v-col sm5>
          <hr style="margin-bottom: 1.5em;" />
          <v-row>
            <v-col xs3 class="text-xs-center">
              <img src="~../assets/images/icon_ar.svg" />
            </v-col>
            <v-col xs9>
              <span class="sub-title">擴增實境</span>
              <p>採用創新擴增實境 (AR) 技術，進行解鎖任務，連結景點場景，體驗浸潤式的英語學習樂趣。</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <!-- 熱門景點 -->
    <section class="pa-5 bg--primary" id="anchor-2">
      <h4 class="title">熱門景點</h4>
      <p class="desc">最受歡迎的臺中熱門景點大推薦</p>

      <v-row class="text-xs-left">
        <v-col sm3>
          <img src="~../assets/images/p_04.png" width="100%" />
          <span class="sub-title">國立自然科學博物館</span>
          <p>位於臺灣臺中市北區的公立科學博物館，由科學中心、太空劇場、生命科學廳、人類文化廳、地球環境廳與植物園所共同組成。每年參觀人數居臺灣博物館第二（僅次於故宮），平均三百萬人。</p>
        </v-col>
        <v-col sm3>
          <img src="~../assets/images/p_03.png" width="100%" />
          <span class="sub-title">勤美術館</span>
          <p>由知名建築師陳瑞憲與郭旭原將大樓重新改裝設計。室內植生牆共13,200株植栽，由地下2樓延伸至地上3樓（高達20公尺）；室外植生牆共118,300株，當時為亞洲最大的植生牆。</p>
        </v-col>
        <v-col sm3>
          <img src="~../assets/images/p_02.png" width="100%" />
          <span class="sub-title">東海大學</span>
          <p>東海大學，是一所基督教新教背景綜合大學，座落於臺中市西屯區大肚山山麓，是第一所在臺灣非改制升格設立且現存的私大。東海大學擁有完整規劃的校園，其建築在台灣近代建築具代表性。</p>
        </v-col>
        <v-col sm3>
          <img src="~../assets/images/p_01.png" width="100%" />
          <span class="sub-title">逢甲夜市</span>
          <p>逢甲夜市，位於臺中市西屯區逢甲大學周圍，屬商圈夜市類型。以文華路、福星路為核心的區域，另外延伸走進文華路可達逢甲旗艦夜市，目前是臺灣規模最大的夜市。</p>
        </v-col>
      </v-row>
    </section>

    <!-- 下載方式 -->
    <section class="pa-5 bg--white" id="anchor-3">
      <h4 class="title">下載方式</h4>
      <p class="desc">這麼酷的APP還不快下載</p>

      <v-row class="pa-3">
        <v-col xs12 offset-sm3 sm3>
          <a href="https://itunes.apple.com/tw/app/%E9%81%8A%E8%87%BA%E4%B8%AD%E5%AD%B8%E8%8B%B1%E8%AA%9E-%E8%8B%B1%E8%AA%9E%E8%A7%80%E5%85%89%E5%9F%8E/id1173769883?l=zh&mt=8" target="_blank">
            <img src="~../assets/images/icon_02.png" />
          </a>
        </v-col>
        <v-col xs12 sm3>
          <a href="https://play.google.com/store/apps/details?id=com.liveabc.android.gbl4g" target="_blank">
            <img src="~../assets/images/icon_03.png" />
          </a>
        </v-col>
      </v-row>

      <v-row class="mt-3 text-xs-left">
        <v-col offset-sm1 sm5>
          <div class="ma-4 pb-4" style="min-height: 9em;">
            <span class="sub-title">Step 1 免費註冊</span>
            <p>下載並開啟『遊臺中學英語』 APP，完成 LiveABC 會員註冊程序，即可免費獲得「國立臺灣美術館」課程，前往景點學習。</p>
          </div>

          <hr />

          <div class="ma-4 pb-4" style="min-height: 9em;">
            <span class="sub-title">Step 2 進入課程</span>
            <p>購買悠活30方案或暢遊365方案，進入學習課程。透過 GPS 定位，開啟互動影音課程，體驗浸潤式的英語學習樂趣。</p>
          </div>

          <hr class="hidden-sm-and-up"  />
        </v-col>
        <v-col sm5>
          <div class="ma-4" style="min-height: 9em;">
            <span class="sub-title">Step 3 挑戰任務</span>
            <p>課程中安排了許多英語學習任務，透過 GPS 定位及 AR 擴增實境，解鎖景點，從生活場域中發現你所看的聽的都是英文，答對了可立即獲得獎勵金幣。</p>
          </div>

          <hr />

          <div class="ma-4 pb-4" style="min-height: 9em;">
            <span class="sub-title">Step 4 兌換好禮</span>
            <p>獎勵金幣達指定數量時，即有機會兌換 LiveABC 提供的學習禮物，實際兌換禮物依網站公告為準。</p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!-- 購買方案 -->
    <section class="pa-5" id="anchor-4">
      <h4 class="primary-color title">購買方案</h4>
      <p class="primary-color desc">選擇適合您的旅遊學習方式，跟著我們走到哪學到哪。</p>

      <v-row class="ma-3 mt-5 text-xs-center average">
        <v-col xs12 sm3 class="ma-3 pa-5 bg--light">
          <span class="sub-title">悠活30方案</span><br />
          30天<br /> 定價 <span style="text-decoration:line-through">300元</span> / 特價 <span style="font-size: 1.3em;">60</span>元<br />
        </v-col>

        <v-col xs12 sm3 class="ma-3 pa-5 bg--light">
          <span class="sub-title">暢遊365方案</span><br />
          365天<br /> 定價 <span style="text-decoration:line-through">900元</span> / 特價 <span style="font-size: 1.3em;">300</span>元<br />
        </v-col>
      </v-row>

      <p class="primary-color mt-5">小編提醒：建議搭配4G行動上網方案體驗「遊臺中學英語」景點課程，確保學習服務順暢。</p>
    </section>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'

  export default {

    name: 'hello',

    data () {
      return {
        slogan: 1,
        intervalId: null
      }
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '首頁',
        link: '/'
      })

      this.mainSectionSwitcher()
    },

    beforeDestroy () {
      clearInterval(this.intervalId)
      this.intervalId = null
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb'
      ]),

      mainSectionSwitcher () {
        var self = this

        if (this.intervalId !== null) {
          clearInterval(this.intervalId)
        }

        this.intervalId = setInterval(() => {
          self.slogan = self.slogan === 1 ? 2 : 1
        }, 5000)
      },

      sloganClick (num) {
        this.slogan = num
        this.mainSectionSwitcher()
      }
    }
  }
</script>

<style lang="scss" scoped>
  section {
    position: relative;
    text-align: center;
    color: #fff;

    .title {
      font-weight: 900;
      font-size: 2em;
    }

    .sub-title {
      font-weight: 900;
      font-size: 1.3em;
      line-height: 200%;
    }

    &.bg--primary,
    .bg--primary {
      background-color: #4a4a66 !important;
      color: #fff !important;
      h4 {
        color: #fff !important;
      }
    }

    &.bg--white,
    .bg--white {
      background-color: #fff !important;
      color: #4a4a66 !important;
      h4 {
        color: #4a4a66 !important;
      }
    }

    &.bg--light,
    .bg--light {
      background-color: #8268b0 !important;
      color: #fff !important;
      h4 {
        color: #fff !important;
      }
    }

    &.main_section {
      height: 70vh;

      .slogan {
        background-color: white;
        width: 50vh;
        max-height: 100vh;
        position: absolute;
        left: 0;
        top: 30%;
        padding: 2em;

        .title {
          color: #4a4a66 !important;
          font-size: 2em;
          font-weight: 900;
        }

        .desc {
          margin-top: 1em;
          color: #4a4a66 !important;
          text-align: left;
        }
      }

      .slogan2 {
        width: 100%;
        height: 25vh;
        position: absolute;
        top: 20%;
        padding: 2em;
        text-align: center;
        color: #4a4a66;
        font-size: 1.6em;
        color: #8268b0 !important;

        .title {
          font-size: 2em;
          font-weight: 900;
        }

        p {
          letter-spacing: 0.6em;
        }
      }

      .sloganPagination {
        position: absolute;
        bottom: 1.5em;
        width: 100%;

        .bg--primary {
          width: 2em;
          height: 2em;
          padding: 0;
        }
      }
    }

    @media screen and (min-width: 768px) {
      .average {
        .col:first-child {
          margin-left: auto !important;
        }

        .col:last-child {
          margin-right: auto !important;
        }
      }
    }
  }

  .main_section {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;

    &.pic--1 {
      background-image: url('~../assets/images/m_02.png');
    }

    &.pic--2 {
      background-image: url('~../assets/images/m_01.png');
    }
  }
</style>



// WEBPACK FOOTER //
// Hello.vue?a9718450